import React from 'react';
import './style.css';

const Mela = (props) => {
	return(
		<div>Mela</div>
	)
}

export default Mela